import {ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject} from '@angular/core';
import {
    AbstractControl,
    FormBuilder,
    FormControl,
    FormGroup,
    FormsModule,
    ReactiveFormsModule,
    ValidationErrors,
    ValidatorFn,
    Validators
} from '@angular/forms';
import {MatSidenav, MatSidenavContainer, MatSidenavContent} from '@angular/material/sidenav';
import {RegisterHeaderComponent} from '../register/register-header/register-header.component';
import {SideBarDoubleComponent} from '../../../shared/components/side-bar-double/side-bar-double.component';
import {ChoiseComponent} from '../../../shared/components/choise/choise.component';
import {MatButton} from '@angular/material/button';
import {MultiSelect3Component} from '../../../shared/components/multi-select3/multi-select3.component';
import {
    AnalyticService,
    ApiAnalyticReportFileGetRequestParams,
    ReferenceService
} from '../../apiModule1';
import { map } from 'rxjs/operators';
import { combineLatest, startWith } from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {quarters, years} from '../index-ias/filter-dialog/filter-dialog.component';
import {NgIf} from "@angular/common";

export function quarterRequiredValidator(val: string): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
        const period = group.get('period')?.value;
        const quarter = group.get('quarter');

        if (period?.name === val && !quarter?.value) {
            quarter?.setErrors({required: true}); // Добавляем ошибку
            return {quarterRequired: true};
        }

        if (quarter?.hasError('required')) {
            quarter.setErrors(null); // Снимаем ошибку, если она больше не актуальна
        }

        return null; // Валидатор не возвращает ошибок
    };
}

// Функция-валидатор, которая проверяет обязательность, только если allOrganization === false
export function conditionalRequiredValidator(allOrganization: () => boolean): ValidatorFn {
    return (control) => {
        const shouldValidate = !allOrganization();
        if (shouldValidate && !control.value) {
            return { required: true };
        }
        return null;
    };
}

@Component({
    selector: 'pas-report-org',
    standalone: true,
    imports: [
        FormsModule,
        MatSidenav,
        MatSidenavContainer,
        MatSidenavContent,
        RegisterHeaderComponent,
        SideBarDoubleComponent,
        ChoiseComponent,
        MatButton,
        MultiSelect3Component,
        ReactiveFormsModule,
        NgIf
    ],
    templateUrl: './report-org.component.html',
    styleUrls: ['./report-org.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportOrgComponent {
    mobileOpen: boolean = false;
    opened: boolean = true;
    analyticService = inject(AnalyticService);

    onClickOutside() {

    }

    referenceService = inject(ReferenceService);
    destroyRef = inject(DestroyRef);
    periods: CriterionPeriod[] = [];
    fb = inject(FormBuilder);
    cdr = inject(ChangeDetectorRef);

    years = years;
    quarters = quarters;
    organizationOptions: any = {};


    form: FormGroup = this.fb.group({
        period: new FormControl<CriterionPeriod | null>(null, [Validators.required]),
        year: new FormControl<(typeof years)[number] | null>(null, [Validators.required]),
        quarter: new FormControl<(typeof quarters)[number] | null>(null, [Validators.required]),
        organization: new FormControl<Organization[] | null>(null, [conditionalRequiredValidator(() => this.form?.get('allOrganization')?.value)]),
        allOrganization: new FormControl(false)
    }, {
        validators: quarterRequiredValidator('Квартальная')

    });

    get period() {
        return this.form.get('period')?.value;
    }

    ngOnInit(): void {
        this.form.get('allOrganization')?.valueChanges
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
                this.form.get('organization')?.updateValueAndValidity();
            });

        this.referenceService.apiReferencePeriodsGet()
            .pipe(map(v => v.values), takeUntilDestroyed(this.destroyRef))
            .subscribe(v => {this.periods = v; this.cdr.markForCheck();});

        combineLatest([
            this.form.get('period')!.valueChanges.pipe(startWith(this.form.get('period')!.value)),
            this.form.get('year')!.valueChanges.pipe(startWith(this.form.get('year')!.value)),
            this.form.get('quarter')!.valueChanges.pipe(startWith(this.form.get('quarter')!.value))])
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(([period, year, quarter]) => {

                this.form.get('organization')!.setValue(null);

                this.organizationOptions = {
                    periodId: period?.id,
                    year: year?.name,
                    quarter: period?.name === 'Квартальная'
                        ? quarter?.name
                        : undefined
                };

                this.cdr.markForCheck();
            });

        this.form.statusChanges
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(status => {
                console.log('status', status);
                console.log('quarter', this.form.get('quarter')?.status);
            });

        this.form.get('organization')!.valueChanges
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(changes => { console.log('organization', changes);
            });
    }


    onApply() {
        const params: ApiAnalyticReportFileGetRequestParams = {
            organizationId: this.form.get('organization')!.value?.[0]?.id,
            periodId: this.form.get('period')!.value?.id,
            year: this.form.get('year')!.value?.name,
            quarter: this.form.get('quarter')!.value?.name,
        }

        if (!this.form.get('allOrganization')!.value) {
            // @ts-ignore
            this.analyticService.apiAnalyticReportFileGet(params, 'response', false, {httpHeaderAccept: 'application/vnd.ms-excel'})
                .subscribe(v => {
                    const data = v.body;
                    const blob = new Blob([data], {type: 'application/vnd.ms-excel'});
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = 'report.xlsx';
                    a.click();
                    window.URL.revokeObjectURL(url);
                })
        } else {
        // @ts-ignore
        this.analyticService.apiAnalyticReportAllOrgsFileZipGet(params, 'response', false, {httpHeaderAccept: 'application/zip'})
            .subscribe(v => {
                const data = v.body;
                const blob = new Blob([data], {type: 'application/zip'});
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'report.zip';
                a.click();
                window.URL.revokeObjectURL(url);
            })
    }
}

onReset()
{
    this.form.reset();
    this.form.get('organization')!.setValue(null);
}
}
